const messages = {
  title: "Boutique",
  description: "Bienvenue dans la boutique premium. Ici, vous pouvez échanger vos points Bridgestone Plus <br/> contre des récompenses de différentes catégories. La gamme de produits <br/> est régulièrement mise à jour. Nous vous souhaitons beaucoup de plaisir lors de votre navigation.",
  sort: {
    asc: "Trier par : Prix le plus bas",
    desc: "Trier par : Prix le plus élevé",
  },
  productSearchBox: {
    from: "points de",
    to: "points à",
  },
  noProducts: "Les critères de recherche n'ont donné aucun résultat",
  quantity: "Quantité",
  search: "Rechercher",
  perPage: "Articles par page",
  timeUnavailable: "Actuellement indisponible pour le moment",
  product: "Produit",
  cart: {
    pointsPerUnit: "Points par unité",
    pointsSum: "Total des points",
  },
  action: "Action",
  pointsTotal: "Total",
  cartRemainPoints: "Points restants au panier",
  shoppingCart: "Panier",
  emptyCart: "Le panier est vide.",
  attributes: "Attributs",
  selectAddressP: "Veuillez sélectionner votre adresse de livraison",
  orderDelivery: "Adresse de livraison",
  selectedProducts: "Produits sélectionnés",
  orderSummary: "Récapitulatif de la commande",
  contactPerson: "Personne de contact",
  selectedAddress: "Adresse sélectionnée",
  urssaf: {
    form: {
      title: "Collecte d’informations – obligations légales (art. L242-1-4 CSS)",
      description: "Certains avantages du programme Bridgestone Plus sont soumis à l’article L242-1-4 du Code de la Sécurité sociale. Dans ce cadre,   \nBridgestone collecte vos informations personnelles et règle les charges sociales associées, données pouvant être communiquées à   \nl’URSSAF en cas de contrôle.",
      firstName: "Prénom",
      lastName: "Nom",
      companyName: "Nom de l’entreprise",
      street: "Rue et numéro",
      postalCode: "Code postal",
      city: "Ville",
      country: "Pays",
      countryHint: "Obligatoire : FR",
      dateOfBirth: "Date de naissance",
      dateFormatHint: "Sera envoyé au format : AAAA-MM-JJ HH:mm:ss",
      placeOfBirth: "Lieu de naissance",
      ssn: "Numéro de sécurité sociale",
      saveAndContinue: "Enregistrer et continuer",
      errors: {
        ssn: "Le numéro de sécurité sociale doit contenir 13 chiffres. Veuillez vérifier votre saisie.",
      },
    },
  },
  order: {
    success: "Merci! Votre commande a été effectuée avec succès. Vous recevrez une confirmation de commande dans votre boîte de réception dans quelques minutes.",
    description: "Vous trouverez ici un aperçu de vos commandes de la boutique de récompenses.",
    info: "Vous trouverez ici un aperçu de vos commandes de la boutique de récompenses.",
    date: "Date de commande",
    number: "N° de commande",
    status: {
      created: "Créée",
      confirm_order: "Confirmer la commande",
      ready_for_shipment: "Prête à l'expédition",
      rejected: "Rejetée",
      processed: "Traitée",
      shipped: "Expédiée",
      returned: "Retournée",
      finished: "Terminée",
    },
    anyOrder: "Pas de commandes",
    products: "Produits",
    quantity_short: "pce(s)",
    itemRemoved: "non livrable",
  },
  orders: "Commandes",
  notEnoughPoints: "Pas assez de points disponibles.",
  statusText: "Statut",
  outOfStock: "Actuellement en rupture de stock",
  productUnavailable: "Ce produit n'est plus disponible.",
  deletedProductsTitle: "Produits non disponibles",
  deletedProductsMessage: "Les produits suivants ne sont plus disponibles. Veuillez les retirer de votre panier pour continuer.",
  removeSelected: "Supprimer la sélection",
  clearCart: "Vider le panier",
  removeSelectedConfirm: "Supprimer les produits sélectionnés de votre panier ?",
  clearCartConfirm: "Supprimer tous les produits de votre panier ?",
  incompleteAddress: {
    firstName: "Veuillez ajouter un prénom à l'adresse de livraison",
    lastName: "Veuillez ajouter un nom à l'adresse de livraison",
    company: "Veuillez ajouter un nom d'entreprise à l'adresse de livraison",
    street: "Veuillez ajouter une rue et un numéro à l'adresse de livraison",
    postalCode: "Veuillez ajouter un code postal à l'adresse de livraison",
    city: "Veuillez ajouter une ville à l'adresse de livraison",
    country: "Veuillez ajouter un pays à l'adresse de livraison",
    phone: "Veuillez ajouter un numéro de téléphone à l'adresse de livraison",
  },
  variant: "Variantes sélectionnables",
  placeOrder: "Commander obligatoirement",
  toOrderDelivery: "Continuer vers l'adresse de livraison",
  toOrderSummary: "Vers l'aperçu des commandes",
  productImg: "Image du produit",
  selectAddressBtn: "Sélectionner l'adresse",
  perPgae: "Articles par page",
  categories: {
    advertising: {
      title: "Matériel publicitaire",
      desc: "Participez directement ici sur la plate-forme et obtenez <br/> 40 points supplémentaires pour le club de primes.",
    },
    rewards: {
      title: "Primes exclusives",
      desc: "Découvrez l'offre de primes  <br/>dans notre centre de formation ou dans vos locaux.",
    },
    tools: {
      title: "Outils d'atelier",
      desc: "Utilisez vos points pour des formations tierces <br/> et réduisez ainsi vos coûts.",
    },
    trainings: {
      title: "Formations et cours",
      desc: "Découvrez l'offre de primes dans notre centre de formation ou dans vos locaux.",
    },
    salesroom: {
      title: "Espace de vente",
      desc: "Mettre en scène l'espace de vente et offrir à votre client un séjour agréable.",
    },
    hunter: {
      title: "Hunter",
      desc: "Échanger des points contre de l'équipement d'atelier attrayant de Hunter.",
    },
  },
  bestSold: "Les plus achetés",
  seasonal: "De saison",
  affordable: "On y est presque",
  forPoints: "pour {points} points",
  reachedPoints: "Score requis atteint",
  remainingPoints: "{points} Points restants",
  favoriteProducts: {
    description: "Vous trouverez ici les produits que vous avez enregistrés.",
  },
  categoryPageDescriptionFallback: "Matériel pour l'atelier ou autres produits de qualité avec le logo Bridgestone pour votre entreprise",
};
export default {
  messages,
};
